import { generateTypes } from '../../utils/HttpReducerHelper';

export const convertToFundingSearch = generateTypes('FUNDING_REPORT', 'CONVERT_TO_FUNDING_SEARCH');
